{
  "daytime": {
    "earlier": "Plus tôt",
    "later": "Plus tard"
  },
  "login": {
    "title": "Se connecter",
    "text": "Connectez-vous à votre compte",
    "button": "Se connecter",
    "stressLevel": "Niveau de stress",
    "errorDialog": {
      "message": "Identifiant ou mot de passe incorrect",
      "accept": "Ok"
    },
    "placeholder": {
      "username": "Veuillez entrer votre identifiant",
      "password": "Veuillez saisir votre mot de passe"
    }
  },
  "sidebar": {
    "bulletins": "Avalanche.report",
    "dangerSources": "Sources de danger",
    "observations": "Observations",
    "incidents": "Incidents",
    "qfa": "QFA",
    "modelling": "Modélisation",
    "modellingForecast": "Prévisions",
    "modellingZamg": "ZAMG multi-modèle",
    "modellingZamgECMWF": "ZAMG ECMWF-EPS",
    "modellingZamgCLAEF": "ZAMG CLAEF-EPS",
    "modellingZamgMeteogram": "GeoSphere météogramme",
    "modellingSnowpack": "SNOWPACK model",
    "modellingSnowpackMeteo": "SNOWPACK modelled meteo",
    "awsome": "AWSOME",
    "snowpack": "SNOWPACK",
    "geosphere": "GeoSphere",
    "lineaexport": "LINEA",
    "awsstats": "Statistiques SPA",
    "yearlystats": "Statistiques annuelles",
    "graphics": "Graphiques",
    "icon": "Météo"
  },
  "weather": {
    "loading": "Chargement des paramètres météorologiques et des images...",
    "noPng": "Image non trouvée.",
    "error": {
      "noParameters": "Aucun paramètre de prévision n'est disponible.",
      "loadFailed": "Impossible de charger les données de prévisions."
    },
    "headings": {
      "model": "Modèle",
      "modelRun": "Simulation",
      "region": "Région de prévision",
      "parameters": "Paramètres",
      "level": "Niveau"
    },
    "alt": {
      "fallback": "Carte des prévisions",
      "image": "{{model}} {{parameter}}{{level}} {{region}} {{date}} {{hour}}Z"
    },
    "models": {
      "icon": "ICON",
      "gfs": "GFS"
    },
    "regions": {
      "atlantic": "Atlantique",
      "europe": "Europe",
      "alps": "Alpes",
      "euregio": "EURORÉGION"
    },
    "levels": {
      "surface": "Surface",
      "cloudTotal": "Total",
      "cloudHigh": "Haut",
      "cloudMid": "Moyen",
      "cloudLow": "Bas"
    },
    "tooltips": {
      "levelApproxElevation": "Hauteur approximative :  ~\n{{height}} m"
    },
    "parameters": {
      "gfs": {
        "equivalentPotentialTemp": "Temp. équivalente potentielle",
        "relativeHumidity": "Humidité relative",
        "geopotentialAndIsotachs": "Geopotential and Isotachs",
        "precipitation": "Precipitation",
        "cape": "CAPE"
      },
      "icon": {
        "cloudCover": "Couverture nuageuse",
        "ns": "Précipitations 1h",
        "ns24": "Précipitations 24h",
        "nsacc": "Précipitations accumulées",
        "nsprob24gt20": "Précip. prob. > 20 mm / 24h",
        "nsprob24gt40": "Précip. prob. > 40 mm / 24h",
        "nsprob24gt80": "Précip. prob.. > 80 mm / 24h",
        "d2m": "Point de rosée 2m",
        "gust": "Rafale de vent max. 10m",
        "cape": "MU-CAPE"
      }
    }
  },
  "menu": {
    "logout": "Se déconnecter",
    "language": "Langue",
    "en": "Anglais",
    "de": "Allemand",
    "fr": "Français",
    "it": "Italien",
    "es": "Espagnol",
    "ca": "Catalan",
    "oc": "Aranais",
    "fullscreen": "Plein écran",
    "settings": "Paramètres",
    "statistics": "Statistiques",
    "admin": "Admin",
    "region": "Région de prévision",
    "education": "Pédagogie"
  },
  "matrix": {
    "label": {
      "snowpackStability": "Stabilité du manteau neigeux",
      "frequency": "Fréquence",
      "avalancheSize": "Taille d'avalanche",
      "dangerRating": "Degré de danger ",
      "override": "(remplacer degré de danger)",
      "matrix": "Matrice",
      "referToFairStability": "Voir stabilité moyenne",
      "referToPoorStability": "Voir stabilité faible",
      "dangerLevel1": "Indice de risque 1 (Faible)"
    }
  },
  "dangerSources": {
    "status": {
      "missing": "manquant",
      "available": "disponible",
      "forecast": "Prévisions",
      "analysis": "analyse",
      "loading": "Chargement des sources de danger...",
      "saveError": "Impossible de sauvegarder la source de danger !",
      "loadDangerSourcesError": "Impossible de charger les sources de danger !",
      "loadVariantsError": "Impossible d'éditer ce type de source.",
      "noTitle": "<no title>"
    },
    "variantStatus": {
      "active": "active",
      "dormant": "endormie",
      "inactive": "inactive"
    },
    "tooltip": {
      "read": "Lire sources de danger",
      "edit": "Éditer sources de danger"
    },
    "table": {
      "loadMore": "Charger {{count}} jours de plus",
      "title": {
        "forecast": "Prévisions",
        "analysis": "Analyse"
      }
    },
    "create": {
      "variantStatus": "Statut",
      "variantEditable": "Ce type de source peut être édité.",
      "variantNotEditable": "Impossible d'éditer ce type de source.",
      "noVariantsForSelectedDay": "Pas de type de source défini pour cette date.",
      "tooltip": {
        "editDangerSource": "Éditer source de danger",
        "loadVariants": "Charger les types de source de la veille",
        "loadVariantsFromForecast": "Charger les variantes de la prévision",
        "showVariantsOnMap": "Afficher les variantes sur la carte",
        "edit": "Éditer les microrégions",
        "copy": "Copier type de source",
        "delete": "Effacer type de source",
        "compare": "Comparer type de source",
        "forecast": "Comparer avec les prévisions"
      },
      "createDangerSource": "Créer source de danger",
      "createVariant": "Créer nouveau type de source",
      "noDangerSources": "Aucune source de danger",
      "title": {
        "slab": "Plaque",
        "weakLayer": "Couche fragile",
        "loose": "Neige meuble",
        "glide": "Neige glissante",
        "matrix": "Matrice",
        "characteristics": "Caractéristiques",
        "comment": "Commentaire",
        "uncertainties": "Incertitude"
      },
      "label": {
        "glidingSnowActivity": "Activité de neige glissante",
        "snowHeight": "Hauteur de neige",
        "snowHeightLowerLimit": "Hauteur de neige min.",
        "snowHeightUpperLimit": "Hauteur de neige max.",
        "snowHeightAverage": "Hauteur moyenne de neige",
        "zeroDegreeIsotherm": "Isotherme 0 °C",
        "looseSnowMoisture": "Humidité de la neige meuble",
        "looseSnowGrainShape": "Forme des grains de neige meuble",
        "slabGrainShape": "Forme des grains de neige de la plaque",
        "slabThickness": "Épaisseur de la plaque",
        "slabThicknessLowerLimit": "Épaisseur min. de la plaque",
        "slabThicknessUpperLimit": "Épaisseur max. de la plaque",
        "slabHandHardness": "Dureté de la plaque au test manuel",
        "slabHandHardnessLowerLimit": "Dureté min. de la plaque au test manuel",
        "slabHandHardnessUpperLimit": "Dureté max. de la plaque au test manuel",
        "slabHardnessProfile": "Dureté de la plaque",
        "slabEnergyTransferPotential": "Potentiel de transfert d'énergie de la plaque",
        "slabDistribution": "Répartition de la plaque",
        "weakLayerGrainShape": "Forme des grains de la couche fragile",
        "weakLayerGrainShapes": "Formes des grains de la couche fragile",
        "weakLayerGrainSize": "Taille des grains de la couche fragile",
        "weakLayerGrainSizeLowerLimit": "Taille min. des grains de la couche fragile",
        "weakLayerGrainSizeUpperLimit": "Taille max. des grains de la couche fragile",
        "weakLayerPersistent": "Persistance de la couche fragile",
        "weakLayerThickness": "Épaisseur de la couche fragile",
        "weakLayerStrength": "Résistance de la couche fragile",
        "weakLayerWet": "La couche fragile, est-elle mouillée ?",
        "weakLayerCrustAbove": "Croûte sur la couche fragile",
        "weakLayerCrustBelow": "Croûte sous la couche fragile",
        "weakLayerPosition": "Position de la couche fragile",
        "weakLayerCreation": "Formation de la couche fragile",
        "weakLayerDistribution": "Répartition de la couche fragile",
        "dangerSpotRecognizability": "Reconnaître les endroits dangereux",
        "remoteTriggering": "Déclenchement à distance",
        "hasDaytimeDependency": "Selon le moment de la journée",
        "dangerIncreaseWithElevation": "Augmentation du danger avec l'altitude",
        "runoutIntoGreen": "Zone de dépôt hors neige",
        "penetrateDeepLayers": "entraîner des couches profondes",
        "highestDangerAspect": "Risque le plus élevé",
        "dangerPeak": "Pic de danger",
        "slopeGradient": "Pente",
        "naturalRelease": "Avalanches spontanées",
        "terrainTypes": "Types de terrain",
        "dangerSigns": "Signes de danger",
        "aspects": "Expositions"
      },
      "createDangerSourceDialog": {
        "title": "Titre",
        "description": "Description",
        "save": "Sauvegarder",
        "cancel": "Annuler"
      },
      "editDangerSourceDialog": {
        "title": "Titre",
        "description": "Description",
        "update": "Mise à jour",
        "cancel": "Annuler"
      },
      "deleteVariantDialog": {
        "message": "Effacer ce type de source ?",
        "accept": "Oui",
        "reject": "Non"
      },
      "noRegionDialog": {
        "message": "Vous devez avoir au moins une microrégion.",
        "accept": "Ok"
      },
      "discardDialog": {
        "message": "Abandonner les modifications ?",
        "accept": "Oui",
        "reject": "Non"
      },
      "saveErrorDialog": {
        "message": "Erreur en sauvegardant les sources de dangers !",
        "accept": "Ok"
      },
      "loadDialog": {
        "message": "Charger tous les types de danger de la veille ?<br><strong>Les types d'analyse existants seront écrasés.</strong>",
        "accept": "Oui",
        "reject": "Non"
      },
      "loadFromForecastDialog": {
        "message": "Charger tous les types de danger de la prévision ?<br><strong>Les types d'analyse existants seront écrasés.</strong>",
        "accept": "Oui",
        "reject": "Non"
      }
    }
  },
  "avalancheType": {
    "title": "Type d'avalanche",
    "slab": "avalanche de plaque",
    "loose": "avalanche de neige meuble",
    "glide": "avalanche de glissement",
    "cornice": "congère",
    "unknown": "inconnue",
    "label": {
      "slab": "PLAQUE DE NEIGE",
      "loose": "NEIGE MEUBLE",
      "glide": "NEIGE GLISSANTE"
    },
    "tooltip": {
      "slab": "Avalanche de plaque",
      "loose": "Avalanche de neige meuble",
      "glide": "Avalanche de glissement"
    }
  },
  "elevation": {
    "title": "Altitude",
    "high": "Au-dessous",
    "low": "Au-dessus",
    "treeline": "Limite de la forêt"
  },
  "bulletins": {
    "title": "Avalanche.report",
    "tooltip": {
      "edit": "Éditer le bulletin",
      "read": "Lire le bulletin",
      "copy": "Copier le bulletin",
      "paste": "Coller le bulletin",
      "cancel": "Annuler la copie",
      "update": "Editer",
      "submit": "Envoyer",
      "submitUpdate": "Envoyer la mise à jour",
      "publishChange": "Publication directe (pas de messages)",
      "publishUpdate": "Publication directe",
      "publishMinimal": "Publication minimale",
      "caaml": "Afficher CAAML",
      "json": "Afficher JSON",
      "create": "Créer le bulletin",
      "preview": "Aperçu du bulletin (PDF)",
      "check": "Vérifier le bulletin",
      "info": "Afficher l'état de la publication",
      "loadSuggestionFromDangerSources": "Charger la suggestion de sources de danger",
      "deleteAllWarningRegions": "Effacer toutes les régions de prévision",
      "publishAll": "Publier toutes les régions de prévision",
      "publishAllNoMessages": "Publier toutes les régions (pas de messages)",
      "mediaFile": "Mise en ligne d'un fichier média",
      "publicationChecklist": "Afficher checklist publications"
    },
    "publicationChecklist": {
      "title": "Checklist publications",
      "description": {
        "website": "La carte indique les degrés de danger à l'aide de couleurs correspondantes. Cliquer sur une région vous affiche les situations avalancheuses et les descriptions associées.",
        "email": "Un mail a été envoyé et contient un rapport.",
        "telegram": "Un message avec un lien vers le site web a été publié.",
        "whatsapp": "Un message avec un lien vers le site web a été publié."
      },
      "ok": "Ok",
      "problem": "Problème",
      "problemDescription": "Description du problème",
      "problemPlaceholder": "Décrivez le problème rencontré",
      "channel": {
        "website": "Site web",
        "whatsapp": "WhatsApp",
        "telegram": "Telegram",
        "email": "Mail"
      },
      "publicationInProgress": "Publication en cours",
      "publicationFinishedOnServer": "Publication sur le serveur terminée",
      "publishDisabled": {
        "inProgress": "Publication en cours",
        "wrongStatus": "Le bulletin doit être envoyé ou publié."
      },
      "emailWaitHint": "L'envoi de mails prend généralement plus de temps que la publication de messages sur les réseaux sociaux. Il faut patienter au moins 5 minutes après la publication avant de passer à l'étape suivante.",
      "email": {
        "waitTitle": "Attendre :"
      },
      "options": "Options",
      "republish": "Publier à nouveau :",
      "resend": "Envoyer à nouveau :",
      "website": {
        "checkInternetTitle": "Vérifier la connexion Internet :",
        "checkInternetDescriptionPrefix": "La connexion Internet sur votre appareil, est-elle bonne ? Ouvrir une fenêtre de navigation privée et aller sur",
        "checkInternetDescriptionSuffix": "Le bulletin d'hier s'affiche-t-il correctement ?",
        "republishHint": "N'effectuez cette étape que si la « vérification de la connexion Internet » s'est déroulée avec succès et qu'au moins 5 minutes se sont écoulées depuis la dernière tentative de publication.",
        "publishMinimalTitle": "Publication minimale :",
        "publishMinimalHint": "Utilisez cette option comme solution de secours en cas d'échec de la publication complète. Elle ne publie que les données CAAML — pas de cartes, de synthèse vocale ni de notifications push. ⚠️ Cela concerne toutes les régions sur ce serveur, pas seulement la vôtre. Toutes seront republiées en mode minimal.",
        "editAndResendTitle": "Éditer et envoyer à nouveau :",
        "openBulletin": "Afficher le bulletin",
        "clickEdit": "Cliquer sur « Éditer »",
        "clickSubmit": "Cliquer sur « Envoyer »",
        "clickPublishNow": "Cliquer sur « Publier maintenant »"
      },
      "manualSend": {
        "title": "Envoyer manuellement :",
        "description": {
          "telegram": "Copiez le texte ci-dessous et envoyez-le au groupe Telegram indiqué.",
          "whatsapp": "Copiez le texte ci-dessous dans le canal WhatsApp indiqué."
        },
        "copyText": "Copiez {{language}} {{channel}} texte"
      },
      "newChecklist": "Nouvelle checklist",
      "savedInfo": "Enregistré par {{user}}, {{time}}",
      "print": {
        "contact": {
          "emailLabel": "E-mail :",
          "nameLabel": "Nom :",
          "phoneLabel": "Téléphone :"
        },
        "emergencyTitle": "En cas de problèmes graves",
        "fallback": {
          "title": "Utilisez une instance de secours :",
          "step1": "Accédez à Admin-GUI de secours pour y publier le bulletin.",
          "step2": "Envoyez manuellement des messages aux chaînes abonnées. Utilisez le texte ci-dessous :",
          "step3": "Informez le public en publiant des messages sur les réseaux sociaux contenant un lien vers l'URL du site web de secours.",
          "step4": "Informez le service des relations publiques de la situation."
        },
        "hide": "Masquer version imprimable",
        "hint": "Indiquez ci-dessous les coordonnées du service d'hébergement et les URL de secours, puis cliquez sur « Imprimer ».",
        "hostingDescription": "Renseignez-vous sur l'état du serveur. Le cas échéant, demandez son redémarrage.",
        "hostingTitle": "Contacter le service d'hébergement :",
        "print": "Imprimer",
        "toggle": "Version imprimable"
      }
    },
    "status": {
      "submittedInfo": "Publication prévue à 17h00",
      "resubmittedInfo": "Publication prévue à 08h00",
      "publishedInfo": "Publié",
      "noPublicationInfo": "PAS de publication automatique",
      "loadingPreview": "Créer un aperçu PDF",
      "loading": "Chargement du bulletin...",
      "loadMoreBulletins": "Charger {{count}} autres bulletins",
      "publishing": "Bulletin en cours de publication...",
      "submitting": "Bulletin en cours d'envoi...",
      "saveError": "Impossible de sauvegarder le bulletin !",
      "loadBulletinsError": "Impossible de charger les bulletins !"
    },
    "create": {
      "tooltip": {
        "edit": "Éditer les microrégions",
        "copy": "Copier la région de prévision",
        "delete": "Effacer la région de prévision",
        "deleteProblem": "Supprimer le problème",
        "compare": "Comparer région de prévision",
        "undo": "Annuler dernière modification dans région de prévision",
        "redo": "Rétablir dernière modification dans région de prévision",
        "createRegion": "Créer région de prévision",
        "cancel": "Annuler",
        "acceptSuggestion": "Accepter les régions proposées",
        "rejectSuggestion": "Refuser les régions proposées",
        "saveChanges": "Sauvegarder les modifications",
        "discardChanges": "Abandonner les modifications",
        "incompleteAvalancheProblem": "Situation avalancheuse typique incomplète",
        "saveBulletin": "Enregistrer le bulletin",
        "discardBulletin": "Abandonner les modifications du bulletin",
        "loadBulletin": "Téléchargement du bulletin de la veille",
        "uploadCaamlBulletin": "Mise en ligne du bulletin au format CAAML",
        "uploadJsonBulletin": "Mettre en ligne au format JSON",
        "downloadCaamlBulletin": "Télécharger le bulletin au format CAAML",
        "downloadJsonBulletin": "Télécharger au format JSON",
        "daytimeDependency": "Selon le moment de la journée",
        "treeline": "Limite de la forêt",
        "tendency": {
          "decreasing": "Le danger d'avalanche diminue",
          "steady": "Le danger d'avalanche reste inchangé",
          "increasing": "Le danger d'avalanche augmente",
          "danger": "Danger d'avalanche"
        },
        "textcat": {
          "edit": "Éditer",
          "copy": "Copier",
          "paste": "Coller",
          "example": "Télécharger exemple de texte",
          "delete": "Effacer"
        },
        "moveUpAvalancheProblem": "Déplacer situation avalancheuse typique en haut",
        "moveDownAvalancheProblem": "Déplacer situation avalancheuse typique en bas",
        "dangerRatingDirectionUp": "Vers le haut",
        "dangerRatingDirectionDown": "Vers le bas",
        "addPhoto": "Ajouter une photo",
        "removePhoto": "Supprimer la photo",
        "uploadPhoto": "Télécharger une photo",
        "editPhoto": "Éditer la photo"
      },
      "save": "Sauvegarder",
      "discard": "Abandonner",
      "back": "Retour",
      "createAggregatedRegion": "Nouvelle région de prévision",
      "pasteAggregatedRegion": "Coller région de prévision",
      "pendingSuggestions": "Suggestions",
      "rejectSuggestion": "Refuser",
      "acceptSuggestion": "Accepter",
      "cancelCopyBulletin": "Annuler",
      "createAvalancheProblem": "Situation avalancheuse typique nouvelle",
      "ownRegions": "Mes régions de prévision",
      "foreignRegions": "Régions étrangères",
      "externalRegions": "Régions externes",
      "mapSelectRegion": "Sélectionner des régions sur la carte.",
      "statusHeader": "Statut du bulletin",
      "suggestions": "Suggestions",
      "noBulletinsForSelectedDay": "Pas de région définie pour cette date.",
      "autosave": "Sauvegardé automatiquement",
      "regionEditable": "Cette région de prévision peut être éditée.",
      "regionNotEditable": "Impossible d'éditer cette région de prévision.",
      "regionLocked": "Cette région de prévision est verrouillée.",
      "changeDangerRatingElevation": "Extension de l'indice de risque",
      "mapTop": "Carte au-dessus",
      "mapLeft": "Carte sur le côté",
      "showExternalRegions": "Afficher les régions externes",
      "hideExternalRegions": "Masquer les régions externes",
      "showNotes": "Afficher les notes",
      "hideNotes": "Masquer les notes",
      "incompleteAvalancheProblem": "Incomplet",
      "label": {
        "generalHeadlineComment": "Titre général",
        "importantObservations": "Observations importantes",
        "avalancheProblems": "Situation avalancheuse typique",
        "aspects": "Expositions",
        "highlights": "Vigilance particulière ",
        "avActivityHighlights": "Titre situation avalancheuse",
        "avActivityComment": "Description du danger d'avalanche",
        "travelAdvisoryHighlights": "Titre de la recommandation",
        "travelAdvisoryComment": "Description de la recommandation",
        "snowpackStructureHighlights": "Titre manteau neigeux",
        "snowpackStructureComment": "Description structure du manteau neigeux",
        "dangerPatterns": "Modèle de risques",
        "tendencyComment": "Description de la tendance",
        "synopsisHighlights": "Titre météo en bref",
        "synopsisComment": "Bulletin météo",
        "notes": "Notes",
        "noSnow": "Pas de neige"
      },
      "copyRegion": {
        "label": "Copier la région de prévision dans un autre bulletin",
        "select": "Copier dans...",
        "currentBulletin": "Ce bulletin"
      },
      "title": {
        "avalancheProblem": "Situations avalancheuses typiques",
        "dangerDescription": "Description du danger d'avalanche",
        "forenoon": "Matin",
        "afternoon": "Après-midi",
        "photos": "Photos",
        "snowpackStructure": "Structure du manteau neigeux",
        "tendency": "Tendance",
        "synopsis": "Météo",
        "showTranslations": "Afficher traductions",
        "hideTranslations": "Masquer traductions"
      },
      "photos": {
        "url": "URL photo",
        "locationName": "Localisation",
        "microregion": "Microrégion",
        "copyright": "Copyright",
        "date": "Date"
      },
      "placeholder": {
        "notes": "Écrivez ici ..."
      },
      "pmDialog": {
        "noIFrameSupport": "Votre navigateur ne supporte pas les IFrames !"
      },
      "discardDialog": {
        "message": "Abandonner les modifications ?",
        "accept": "Oui",
        "reject": "Non"
      },
      "deleteAggregatedRegionDialog": {
        "message": "Effacer cette région ?",
        "accept": "Oui",
        "reject": "Non"
      },
      "noRegionDialog": {
        "message": "Vous devez avoir au moins une microrégion.",
        "accept": "Ok"
      },
      "loadDialog": {
        "message": "Charger les bulletins de la veille ?<br><strong>Les régions actuelles seront effacées.</strong>",
        "accept": "Oui",
        "reject": "Non"
      },
      "deleteAllWarningRegionsDialog": {
        "message": "Effacer toutes les régions de prévision ?",
        "accept": "Oui",
        "reject": "Non"
      },
      "loadSuggestionsFromDangerSourcesDialog": {
        "message": "Charger des suggestions de sources de danger ?<br><strong>Les régions actuelles seront effacées !</strong>",
        "accept": "Oui",
        "reject": "Non"
      },
      "loadAutoSaveDialog": {
        "message": "Télécharger le bulletin sauvegardé automatiquement ?",
        "accept": "Oui",
        "reject": "Non"
      },
      "saveErrorDialog": {
        "message": "Erreur en sauvegardant les bulletins !",
        "accept": "Ok"
      },
      "changeErrorDialog": {
        "message": "Erreur lors de la modification des bulletins !",
        "accept": "Ok"
      },
      "loadingErrorDialog": {
        "message": "Erreur lors du téléchargement des bulletins !",
        "accept": "Ok"
      },
      "loadingJsonFileErrorDialog": {
        "message": "Erreur de chargement des bulletins du fichier JSON",
        "accept": "Ok"
      },
      "avalancheProblemErrorDialog": {
        "message": "Problème d'avalanche, expositions, stabilité du manteau neigeux, fréquence et/ou taille de l'avalanche manquent pour au moins un problème d'avalanche.",
        "accept": "Ok"
      },
      "loadAvActivityCommentExampleTextDialog": {
        "message": "Pour quelle situation souhaitez-vous charger un exemple de texte",
        "newSnow": "Neige fraîche",
        "windSlab": "Plaque à vent",
        "persistentWeakLayers": "Neige ancienne (Sous-couche fragile persistante)",
        "wetSnow": "Avalanches mouillées (Neige humide)",
        "glidingSnow": "Avalanches de glissement (Avalanches de fond)",
        "favourableSituation": "Situation favorable",
        "cancel": "Annuler"
      },
      "removeDaytimeDependencyDialog": {
        "message": "Quelles sont les situations avalancheuses que vous souhaitez conserver ?",
        "cancel": "Annuler"
      },
      "strategicMindsetDialog": {
        "title": "États d'esprit stratégiques",
        "introduction": "L'« état d'esprit stratégique » a pour but d'exprimer notre attitude mentale à l'égard de la situation avalancheuse et de son évolution dans la région de prévision correspondante. Il ne doit pas découler directement de l'évaluation des dangers, mais plutôt être compris et utilisé comme une impression intuitive de la situation globale. Les « états d'esprit stratégiques » sont donc avant tout un outil de communication. En les utilisant ainsi que les définitions associées, nous, prévisionnistes, pouvons échanger rapidement et efficacement des informations sur l'évolution de la situation de danger et trouver un langage commun pour la communication.",
        "description": {
          "title": "Description :",
          "text": {
            "assessment": "L'évaluation du danger est <b>très incertaine</b> en raison d'<b>informations insuffisantes</b> provenant du terrain.",
            "stepping_out": "<b>Tendance à la baisse</b> du danger d'avalanche (y compris à l'intérieur d'un indice de danger).",
            "status_quo": "Même situation de danger. <b>Pas de changement significatif</b> par rapport à la veille.",
            "stepping_back": "<b>Tendance à l'augmentation</b> du danger d'avalanche (y compris à l'intérieur d'un indice de danger).",
            "entrenchment": "<b>Situation avalancheuse presque constante et tendue.</b> Le principal danger provient d'une ou plusieurs <b>couches faibles persistantes</b> susceptibles de se déclencher.",
            "free_ride": "<b>Faible risque d'avalanche</b> avec une couverture neigeuse généralement stable. Seules de petites avalanches sont possibles sur les terrains extrêmement escarpés.",
            "high_alert": "Situation avalancheuse exceptionnelle avec un <b>indice de risque fort à très fort</b>. Des avalanches spontanées <b>très grandes ou d'ampleur exceptionnelle</b> sont possibles.",
            "spring_diurnal": "Des avalanches de neige mouillée durant la journée qui sont soumises à un <b>net réchauffement durant la journée</b> sont décisives pour l'évaluation des risques."
          }
        },
        "communication": {
          "title": "Communication :",
          "text": {
            "assessment": "La situation avalancheuse doit être évaluée sur place. Sortie déconseillée.",
            "stepping_out": "Diminution progressive du danger. Toutefois, la prudence reste de mise et il convient d'évaluer localement l'amélioration de la situation avant de s'engager sur un terrain plus risqué. ",
            "status_quo": "La situation de danger reste inchangée. Les retours d'observateurs permet de mieux définir la situation de danger. Dans la communication, il faudrait mettre en avant les terrains plus favorables. ",
            "stepping_back": "Communication claire de l'augmentation du danger d'avalanche - y compris dans un même indice de risque. Communiquer sur les causes garantit une meilleure compréhension. ",
            "entrenchment": "Prudence et vigilance s'imposent. La situation n'évolue guère. Si possible, fournir des informations aussi précises que possible sur la distribution et un possible déclenchement. Intensifier la communication des observations illustrant la situation pour susciter la vigilance.",
            "free_ride": "Peu de texte. Souligner la situation générale favorable et les zones de danger potentiellement isolées.",
            "high_alert": "Communication sur tous les canaux. L'accent n'est plus mis sur les sports d'hiver. Le danger existe même dans des zones qui, habituellement, ne sont pas exposées au risque d'avalanche.",
            "spring_diurnal": "Situation favorable le matin, s'accentuant durant la journée. L'évaluation doit se faire localement en observant le ramollissement de la croûte de regel et la saturation croissante en eau du manteau neigeux."
          }
        },
        "examples": {
          "title": "Exemples :",
          "text": {
            "assessment": "Début de saison.",
            "stepping_out": "Le refroidissement entraîne une diminution du risque d'avalanches de neige mouillée après une phase de temps chaud et humide.",
            "status_quo": "Problème constant de plaques à vent avec des températures froides, de la neige meuble et du vent.",
            "stepping_back": "L'abondance de neige fraîche entraîne une augmentation des situations avalancheuses.",
            "entrenchment": "Problème sérieux de couches faibles persistantes avec risque d'avalanches de grande ampleur. La situation ne se stabilise que très lentement et nécessite une grande vigilance.",
            "free_ride": "Faible danger d'avalanche, pas de couches faibles persistantes, tous les terrains ont déjà été damés.",
            "high_alert": "Indice de danger 4 ou plus en raison de grandes quantités de neige fraîche et/ou de couches faibles problématiques et persistantes. ",
            "spring_diurnal": "Situation printanière avec un temps anticyclonique sec et des températures modérées ainsi qu'un manteau neigeux ancien généralement stable."
          }
        },
        "strategicMindset": {
          "assessment": "Grande incertitude",
          "stepping_out": "En cours d'amélioration",
          "status_quo": "Statu quo",
          "stepping_back": "En cours de détérioration",
          "entrenchment": "Persistante instable",
          "free_ride": "Favorable",
          "high_alert": "Vigilance rouge",
          "spring_diurnal": "Situation de printemps"
        }
      },
      "decisionTree": {
        "filepath": "./assets/img/decision_tree-en.svg",
        "feedbackURL": "https://admin.avalanche.report/umfrage-entscheidungsbaum/en/",
        "decisionTree": "Arbre de décision",
        "feedback": "Retour d'informations",
        "save": "Sauvegarder",
        "discard": "Abandonner"
      }
    },
    "table": {
      "title": {
        "date": "Date"
      },
      "status": {
        "missing": "manquant",
        "draft": "ébauche",
        "submitted": "envoyé",
        "published": "publié",
        "updated": "mis à jour",
        "resubmitted": "envoyé à nouveau",
        "republished": "publié à nouveau"
      },
      "publishBulletinsDialog": {
        "message": "Publier le bulletin ?"
      },
      "publicationStatusDialog": {
        "headline": "Statut de publication",
        "publishedBy": "Publié par :",
        "publishedAt": "Publié à :",
        "validFor": "Valide pour:",
        "title": {
          "prod": "Système productif",
          "test": "Test système",
          "task": "Tâche",
          "language": {
            "all": "TOUT",
            "de": "DE",
            "it": "IT",
            "en": "EN"
          }
        },
        "email": {
          "label": "E-mails",
          "tooltip": "Envoyer e-mails",
          "success": "Mails envoyés !",
          "error": "Échec envoi mails !"
        },
        "telegram": {
          "label": "Messages Telegram",
          "tooltip": "Envoyer messages Telegram",
          "success": "Messages Telegram envoyés !",
          "error": "Échec envoi messages Telegram !"
        },
        "whatsapp": {
          "label": "Messages WhatsApp",
          "tooltip": "Envoyer messages WhatsApp",
          "success": "Messages WhatsApp envoyés !",
          "error": "Échec envoi messages WhatsApp !"
        },
        "push": {
          "label": "Notifications push",
          "tooltip": "Envoyer notifications push",
          "success": "Notifications push envoyées !",
          "error": "Échec envoi notifications push !"
        },
        "accept": "Ok",
        "confirm": "Envoyer {{channel}} ({{language}}) ?"
      },
      "mediaFileDialog": {
        "headline": "Fichier média",
        "important": "IMPORTANT",
        "missingFile": "Aucun fichier sélectionné !",
        "uploadError": "Échec de mise en ligne !",
        "accept": "Envoyer",
        "reject": "Annuler"
      },
      "publishBulletinsErrorDialog": {
        "message": "Erreur lors de la publication des bulletins !",
        "accept": "Ok"
      },
      "submitBulletinsDialog": {
        "message": "Envoyer le bulletin ?"
      },
      "submitBulletinsErrorDialog": {
        "message": "Erreur lors de l'envoi des bulletins !",
        "accept": "Ok"
      },
      "submitBulletinsDuplicateRegionDialog": {
        "message": "Régions de prévision évaluées plusieurs fois ! Impossible d'envoyer le bulletin.",
        "accept": "Ok"
      },
      "checkBulletinsErrorDialog": {
        "message": "Erreur lors du contrôle des bulletins !",
        "accept": "Ok"
      },
      "previewErrorDialog": {
        "message": "Impossible de charger l'aperçu",
        "accept": "Ok"
      },
      "checkBulletinsDialog": {
        "message": "Contrôler le bulletin",
        "ok": "(tout bon)"
      },
      "publishAllDialog": {
        "message": "Publier toutes les régions ?",
        "changeMessage": "Publier toutes les régions ? (pas de messages)"
      },
      "bulletinCheck": {
        "missingDangerRating": "Indice de risque non défini",
        "missingDangerRatingModificator": "Le modificateur de l'indice de risque n'est pas défini",
        "missingRegion": "Régions non évaluée",
        "duplicateRegion": "Régions notées plusieurs fois",
        "missingAvActivityHighlights": "Titre situation avalancheuse manque",
        "missingAvActivityComment": "Description du danger d'avalanche manque",
        "missingSnowpackStructureHighlights": "Titre structure du manteau neigeux manque",
        "missingSnowpackStructureComment": "Description structure du manteau neigeux manque",
        "pendingSuggestions": "Propositions en attente",
        "incompleteTranslation": "Traduction incomplète"
      }
    }
  },
  "training": {
    "training": "Exercice",
    "timestamp": "Moment de l'exercice"
  },
  "admin": {
    "loadingStatistics": "CSV en cours de création...",
    "server-configuration": {
      "title": "Serveur",
      "button": {
        "create": "Ajouter serveur",
        "save": "Sauvegarder"
      },
      "table": {
        "name": "Nom",
        "userName": "Nom d'utilisateur",
        "password": "Mot de passe",
        "publishAt5PM": "Publier à 17h00",
        "publishAt8AM": "Publier à 08h00",
        "pdfDirectory": "Répertoire pour PDF",
        "htmlDirectory": "Répertoire pour HTML",
        "serverImagesUrl": "Chemin vers les images du serveur",
        "dangerLevelElevationDependency": "Dépendance du degré de danger en fonction de l'altitude",
        "mapsPath": "Chemin vers les cartes",
        "mediaPath": "Chemin vers les fichiers média",
        "mapProductionUrl": "URL pour la production des cartes",
        "apiUrl": "API URL"
      },
      "success": "Configuration sauvegardée avec succès",
      "error": "Impossible de sauvegarder la configuration"
    },
    "region-configuration": {
      "title": "Région de prévision",
      "button": {
        "create": "Créer région de prévision",
        "save": "Sauvegarder"
      },
      "table": {
        "general": {
          "title": "Général"
        },
        "publication": {
          "title": "Publication"
        },
        "components": {
          "title": "Composantes"
        },
        "configuration": {
          "title": "Configuration"
        },
        "languageConfiguration": {
          "title": "Configuration langue"
        }
      },
      "success": "Configuration sauvegardée avec succès",
      "error": "Impossible de sauvegarder la configuration"
    },
    "users": {
      "title": "Utilisateurs",
      "button": {
        "create": "Créer utilisateur"
      },
      "tooltip": {
        "edit": "Éditer utilisateur",
        "changePassword": "Modifier le mot de passe",
        "delete": "Supprimer utilisateur"
      },
      "table": {
        "name": "Nom",
        "email": "Mail",
        "organization": "Organisation",
        "regions": "Régions de prévision",
        "roles": "Fonctions"
      },
      "deleteUserModalDialog": {
        "message": "Voulez-vous supprimer l'utilisateur ?",
        "accept": "Oui",
        "reject": "Non"
      },
      "deleteUser": {
        "success": "Utilisateur supprimé",
        "error": "Impossible de supprimer l'utilisateur"
      },
      "createUser": {
        "success": "Utilisateur créé",
        "error": "Impossible de créer l'utilisateur"
      },
      "updateUser": {
        "success": "Utilisateur sauvegardé",
        "error": "Impossible de sauvegarder l'utilisateur"
      }
    },
    "createUser": {
      "table": {
        "image": "Image",
        "name": "Nom",
        "email": "Mail",
        "organization": "Organisation",
        "password": "Mot de passe",
        "password2": "Répéter le mot de passe",
        "roles": "Fonctions",
        "regions": "Régions de prévision"
      },
      "error": {
        "name": {
          "required": "Veuillez saisir un nom"
        },
        "email": {
          "required": "Veuillez saisir une adresse mail",
          "invalid": "Adresse mail invalide"
        },
        "password": {
          "required": "Veuillez saisir le mot de passe",
          "length": "Le mot de passe doit contenir au moins 8 caractères",
          "mismatch": "Les mots de passe ne sont pas identiques"
        }
      },
      "button": {
        "create": "Créer utilisateur",
        "update": "Mettre à jour l'utilisateur",
        "cancel": "Annuler"
      }
    },
    "observations": {
      "table": "Tableau",
      "map": "Carte",
      "gallery": "Galerie",
      "filters": "Filtres",
      "details": "Détails",
      "title": "Observations",
      "newObservation": "Ajouter une observation",
      "exportObservations": "Exporter observations (GeoJSON)",
      "exportStatistics": "Exporter statistiques (CSV)",
      "toggleFilterBar": "Afficher/masquer barre de filtres",
      "button": {
        "submit": "Télécharger"
      },
      "label": {
        "dateRange": "Période",
        "observer": "Observateur"
      },
      "selectRegion": {
        "placeholder": "Région de prévision",
        "selectionLabel": "{0} région(s) sélectionnée(s)"
      },
      "selectSources": {
        "placeholder": "Sources",
        "selectionLabel": "{0} source(s) sélectionnée(s)"
      },
      "charts": {
        "charts": "Diagrammes",
        "nan": "Pas d'informations",
        "reload": "Recharger",
        "classify": "Classifier",
        "label": "Description",
        "invert": "Inverser",
        "reset": "Réinitialiser",
        "aspect": {
          "caption": "Exposition"
        },
        "elevation": {
          "caption": "Altitude"
        },
        "stability": {
          "caption": "Stabilité"
        },
        "observationType": {
          "caption": "Type d'observation"
        },
        "importantObservation": {
          "caption": "Important"
        },
        "avalancheProblem": {
          "caption": "Situation avalancheuse typique"
        },
        "dangerPattern": {
          "caption": "Modèle de risques"
        },
        "dangerSource": {
          "caption": "Source de danger"
        },
        "days": {
          "caption": "Jour"
        }
      }
    },
    "blog": {
      "title": "Blog",
      "language": {
        "title": "Langue",
        "de": "DE",
        "it": "IT",
        "en": "EN"
      },
      "all": {
        "tooltip": "Envoyer mails, messages Telegram et notifications push",
        "success": "Mail, message Telegram et notification push envoyés !",
        "error": "Échec envoi mail, message Telegram et notification push !"
      },
      "email": {
        "tooltip": "Envoyer mails",
        "success": "Mail envoyé !",
        "error": "Échec envoi mail !"
      },
      "telegram": {
        "tooltip": "Envoyer via un canal Telegram",
        "success": "Message Telegram envoyé !",
        "error": "Échec envoi message Telegram !"
      },
      "whatsapp": {
        "tooltip": "Envoyer via un canal WhatsApp",
        "success": "Message WhatsApp envoyé !",
        "error": "Échec envoi message WhatsApp !"
      },
      "push": {
        "tooltip": "Envoyer notifications push",
        "success": "Notification push envoyée !",
        "error": "Échec envoi notification push !"
      }
    }
  },
  "settings": {
    "title": "Paramètres",
    "effectiveRole": "Rôle effectif",
    "effectiveRoleDefault": "Tous les rôles",
    "changePassword": {
      "title": "Modifier le mot de passe",
      "oldPassword": {
        "label": "Mot de passe actuel",
        "placeholder": "Mot de passe actuel"
      },
      "newPassword1": {
        "label": "Nouveau mot de passe",
        "placeholder": "Nouveau mot de passe"
      },
      "newPassword2": {
        "label": "Nouveau mot de passe (répéter)",
        "placeholder": "Nouveau mot de passe"
      },
      "submit": "Modifier le mot de passe",
      "passwordChanged": "Mot de passe changé avec succès",
      "passwordChangeError": "Impossible de changer le mot de passe",
      "passwordIncorrect": "Mot de passe actuel incorrect",
      "error": {
        "oldPassword": {
          "required": "Saisissez votre mot de passe actuel"
        },
        "newPassword": {
          "required": "Saisissez votre nouveau mot de passe ",
          "mismatch": "Les mots de passe ne sont pas identiques"
        }
      }
    },
    "display": {
      "title": "Afficher",
      "table": {
        "showCaaml": "Afficher CAAML",
        "showJson": "Afficher JSON"
      }
    }
  },
  "statistics": {
    "title": "Statistiques",
    "bulletins": "Bulletins d'avalanches",
    "dangerSources": "Sources de danger",
    "button": {
      "submit": "Télécharger"
    },
    "label": {
      "dateRange": "Période",
      "extended": "Étendue",
      "duplicates": "Doublons"
    },
    "error": {
      "downloadFailed": "Le téléchargement de l'exportation des statistiques a échoué. Veuillez réessayer."
    }
  },
  "dangerRating": {
    "missing": "manquant",
    "noRating": "pas noté",
    "no_rating": "pas noté",
    "no_snow": "pas de neige",
    "low": "faible",
    "moderate": "limité",
    "considerable": "marqué",
    "high": "fort",
    "very_high": "très fort",
    "veryHigh": "très fort"
  },
  "avalancheProblem": {
    "newSnow": "Neige fraîche",
    "new_snow": "Neige fraîche",
    "windSlab": "Plaque à vent",
    "wind_slab": "Plaque à vent",
    "persistentWeakLayers": "Neige ancienne (Sous-couches fragiles persistantes)",
    "persistent_weak_layers": "Neige ancienne (Sous-couches fragiles persistantes)",
    "wetSnow": "Avalanches mouillées (Neige humide)",
    "wet_snow": "Avalanches mouillées (Neige humide)",
    "glidingSnow": "Avalanches de glissement (Avalanches de fond)",
    "gliding_snow": "Avalanches de glissement (Avalanches de fond)",
    "cornices": "Congères",
    "noDistinctAvalancheProblem": "Pas de situation avalancheuse particulière",
    "no_distinct_avalanche_problem": "Pas de situation avalancheuse particulière",
    "favourableSituation": "Situation favorable",
    "favourable_situation": "Situation favorable"
  },
  "dangerPattern": {
    "dp1": "mr.1 : sous-couche fragile persistante",
    "dp2": "mr.2 : neige glissante",
    "dp3": "mr.3 : pluie",
    "dp4": "mr.4 : froid suivant chaud / chaud suivant froid",
    "dp5": "mr.5 : chute de neige après une longue période de froid",
    "dp6": "mr.6 : neige meuble et vent",
    "dp7": "mr.7 : enneigement faible à coté d'enneigement abondant",
    "dp8": "mr.8 : givre de surface recouvert de neige",
    "dp9": "mr.9 : neige roulée recouverte de neige",
    "dp10": "mr.10 : situation de printemps"
  },
  "strategicMindset": {
    "title": "État d'esprit stratégique",
    "assessment": "Grande incertitude",
    "stepping_out": "En cours d'amélioration",
    "status_quo": "Statu quo",
    "stepping_back": "En cours de détérioration",
    "entrenchment": "Persistante instable",
    "free_ride": "Favorable",
    "high_alert": "Vigilance rouge",
    "spring_diurnal": "Situation de printemps"
  },
  "observationType": {
    "DrySnowfallLevel": "Limite des chutes de neige sèche",
    "TimeSeries": "Série chronologique",
    "Incident": "Incident",
    "Profile": "Profil de neige",
    "Closure": "Fermeture",
    "Blasting": "Minage",
    "Avalanche": "Avalanche",
    "Evaluation": "Évaluation",
    "SimpleObservation": "Observation simple",
    "Webcam": "Webcam"
  },
  "importantObservation": {
    "ForBlog": "Pour le blog",
    "SurfaceHoar": "Givre de surface",
    "Graupel": "Neige roulée",
    "StabilityTest": "Test de stabilité",
    "IceFormation": "Formation de glace",
    "VeryLightNewSnow": "Neige fraîche très légère"
  },
  "elevationTolerance": {
    "exact": "exacte",
    "50m": "±50m",
    "100m": "±100m",
    "200": "±200m"
  },
  "elevationPeriod": {
    "duringPrecipitationEvent": "Limite de neige sèche pendant l'épisode de précipitations",
    "observationPeriod": "Limite de neige sèche au moment de l'observation"
  },
  "aspect": {
    "N": "N",
    "NE": "NE",
    "E": "E",
    "SE": "SE",
    "S": "S",
    "SW": "SO",
    "W": "O",
    "NW": "NO"
  },
  "role": {
    "SUPERADMIN": "Superadministrateur",
    "ADMIN": "Administrateur",
    "FORECASTER": "Prévisionniste",
    "FOREMAN": "Contremaître",
    "OBSERVER": "Observateur"
  },
  "tendency": {
    "decreasing": "Le danger d'avalanche diminue",
    "steady": "Le danger d'avalanche reste inchangé",
    "increasing": "Le danger d'avalanche augmente"
  },
  "snowpackStability": {
    "unknown": "inconnue",
    "good": "stable",
    "fair": "moyennement stable",
    "poor": "instable",
    "very_poor": "très instable"
  },
  "frequency": {
    "none": "(pratiquement) pas",
    "few": "quelques-uns",
    "some": "plusieurs",
    "many": "beaucoup"
  },
  "avalancheSize": {
    "small": "petit",
    "small_medium": "petite à moyenne",
    "medium": "moyenne",
    "medium_large": "moyenne à grande",
    "large": "grande",
    "large_very_large": "grande à très grande",
    "very_large": "très grande",
    "very_large_extreme": "très grande à extrême",
    "extreme": "extrême",
    "unknown": "inconnue"
  },
  "complexity": {
    "easy": "Facile",
    "challenging": "Exigeant",
    "complex": "Complexe"
  },
  "glidingSnowActivity": {
    "low": "faible",
    "medium": "moyen",
    "high": "fort"
  },
  "wetness": {
    "dry": "sec",
    "moist": "mouillé",
    "wet": "humide"
  },
  "characteristic": {
    "low": "faible",
    "medium": "moyen",
    "high": "fort",
    "very_high": "très fort"
  },
  "thickness": {
    "thin": "mince",
    "thick": "épais"
  },
  "snowpackPosition": {
    "upper": "au-dessus",
    "middle": "au milieu",
    "lower": "en-dessous",
    "ground": "sol"
  },
  "weakLayerCrust": {
    "no": "non",
    "partly": "en partie",
    "yes": "oui"
  },
  "creationProcess": {
    "radiation_recrystallization": "rayonnement",
    "diurnal_recrystallization": "Croûte de regel",
    "melt_layer_recrystallization": "couche de fonte",
    "surface_hoar_formation": "givre de surface"
  },
  "recognizability": {
    "very_easy": "très facile",
    "easy": "facile",
    "hard": "difficile",
    "very_hard": "très difficile"
  },
  "distribution": {
    "isolated": "isolé",
    "specific": "définissable",
    "widespread": "étendu"
  },
  "probability": {
    "likely": "probable",
    "possible": "possible",
    "unlikely": "improbable"
  },
  "detailedDaytime": {
    "evening": "soir",
    "first_night_half": "première partie de nuit",
    "second_night_half": "seconde partie de nuit",
    "morning": "tôt le matin",
    "forenoon": "matin",
    "afternoon": "après-midi"
  },
  "slopeGradient": {
    "moderately_steep": "modérément raides",
    "steep": "raides",
    "very_steep": "très raides",
    "extremely_steep": "extrêmement raides"
  },
  "handHardness": {
    "fist": "F",
    "four_fingers": "4F",
    "one_finger": "1F",
    "pencil": "P",
    "knife": "K",
    "ice": "I"
  },
  "hardnessTendency": {
    "decreasing": "plus meuble au-dessous",
    "steady": "régulier",
    "increasing": "plus meuble au-dessus"
  },
  "terrainType": {
    "gullies_and_bowls": "combes et couloirs",
    "adjacent_to_ridgelines": "à proximité des crêtes",
    "distant_from_ridgelines": "loin des crêtes",
    "in_the_vicinity_of_peaks": "près des sommets",
    "pass_areas": "zones de col",
    "shady_slopes": "versants à l'ombre",
    "sunny_slopes": "versants au soleil",
    "grassy_slopes": "versants herbeux",
    "cut_slopes": "talus",
    "wind_loaded_slopes": "versants où la neige s’est accumulée",
    "base_of_rock_walls": "pied des parois rocheuses",
    "behind_abrupt_changes_in_the_terrain": "versants derrière les ruptures de terrain",
    "transitions_into_gullies_and_bowls": "transitions vers combes et couloirs",
    "areas_where_the_snow_cover_is_rather_shallow": "endroits plutôt peu enneigés",
    "transitions_from_a_shallow_to_a_deep_snowpack": "transition d'un manteau neigeux peu épais à un manteau neigeux épais",
    "highly_frequented_off_piste_terrain": "terrain hors-piste très fréquenté",
    "little_used_backcountry_terrain": "terrain hors-pistes peu fréquenté",
    "places_that_are_protected_from_the_wind": "endroits à l'abri du vent",
    "regions_exposed_to_the_foehn_wind": "régions exposées au foehn",
    "regions_with_a_lot_of_snow": "régions où il neige beaucoup",
    "regions_exposed_to_precipitation": "régions exposées à des précipitations",
    "regions_exposed_to_heavier_precipitation": "régions exposées à des précipitations abondantes"
  },
  "dangerSign": {
    "shooting_cracks": "fissures",
    "whumpfing": "bruit d'effondrement",
    "fresh_avalanches": "avalanche fraîche",
    "glide_cracks": "fissures de glissement"
  },
  "changeRegionDialog": {
    "message": "Voulez-vous changer de région de prévision ?",
    "accept": "Oui",
    "reject": "Non"
  },
  "zamg": {
    "table": "Tableau",
    "map": "Carte",
    "region": "Région de prévision",
    "newSnow": "Neige fraîche"
  },
  "snowpack": {
    "plotType": {
      "LWC_stratigraphy": "neige humide: teneur en eau liquide",
      "wet_snow_instability": "neige humide: instabilité de la neige mouillée",
      "Sk38_stratigraphy": "couches fragiles persistantes: SK38 index de stabilité",
      "stratigraphy": "couches fragiles persistantes : stratigraphie de la neige"
    },
    "aspect": {
      "flat": "terrain plat",
      "north": "versant nord",
      "south": "versant sud"
    },
    "meteo": {
      "new_snow_plot_3day": "neige fraîche (3j)",
      "new_snow_plot_7day": "neige fraîche (7j)",
      "new_snow_plot_1month": "neige fraîche (31j)",
      "new_snow_plot_season": "neige fraîche (toute la saison)",
      "new_snow_plot_forecast": "neige fraîche (prévisons)",
      "wet_snow_plot_3day": "neige humide (3j)",
      "wet_snow_plot_7day": "neige humide (7j)",
      "wet_snow_plot_1month": "neige humide (31j)",
      "wet_snow_plot_season": "neige humide (toute la saison)",
      "wet_snow_plot_forecast": "neige humide (prévisions)",
      "HS_table_24h": "tableau hauteur de neige (1j)",
      "HS_table_72h": "tableau hauteur de neige (3j)",
      "HS_table_season": "tableau hauteur de neige (toute la saison)",
      "HS_table_forecast": "tableau hauteur de neige (prévisions)",
      "TA_table_24h": "tableau température (1j)",
      "TA_table_72h": "tableau température (3j)",
      "TA_table_season": "tableau température (toute la saison)"
    }
  },
  "grainShape": {
    "PP": {
      "code": "PP",
      "class": "Neige fraîche"
    },
    "PPgp": {
      "code": "PPgp",
      "class": "Neige roulée"
    },
    "DF": {
      "code": "DF",
      "class": "Particules reconnaissables"
    },
    "RG": {
      "code": "RG",
      "class": "Grains arrondis"
    },
    "FC": {
      "code": "FC",
      "class": "Grains anguleux"
    },
    "FCxr": {
      "code": "FCxr",
      "class": "Grains anguleux arrondis"
    },
    "DH": {
      "code": "DH",
      "class": "Givre de profondeur"
    },
    "SH": {
      "code": "SH",
      "class": "Givre de surface"
    },
    "MF": {
      "code": "MF",
      "class": "Formes de fonte"
    },
    "MM": {
      "code": "MM",
      "class": "Neige de culture"
    },
    "MFcr": {
      "code": "MFcr",
      "class": "Croûte de regel"
    },
    "IF": {
      "code": "IF",
      "class": "Formations de glace"
    }
  },
  "button": {
    "true": "Oui",
    "false": "Non",
    "ok": "Ok",
    "yes": "Oui",
    "no": "Non"
  },
  "observations": {
    "$externalURL": "URL externe (p. ex. banque d'images)",
    "$type": "Type d'observation",
    "allowEdit": "Éditer observations externes",
    "allowEditTooltip": "Cela évitera l'écrasement par {{ value }}",
    "editIconTooltip": "Observation éditée - sans mise à jour par {{ value }}",
    "aspect": "Exposition",
    "authorName": "Nom de l'auteur",
    "avalancheLength": "Longueur d'avalanche",
    "avalancheProblem": "Situation avalancheuse typique",
    "avalancheProblems": "Situation avalancheuse typique",
    "avalancheSize": "Taille d'avalanche",
    "avalancheType": "Type d'avalanche",
    "avalancheWidth": "Largeur d'avalanche",
    "search": "Rechercher",
    "count": "# observations :",
    "elevationTolerance": "Précision des données altimétriques",
    "elevationPeriod": "Altitude laps de temps",
    "layers": {
      "observers": "Observateurs",
      "weatherStations": "Stations météo ",
      "webcams": "Webcams",
      "observations": "Observations"
    },
    "weatherStations": {
      "tooltips": {
        "drySnowfallLevel": "Limite des chutes de neige sèche",
        "globalRadiation": "Rayonnement global",
        "newSnow": "Neige fraîche",
        "snowLine": "Limite de l'enneigement",
        "snowHeight": "Hauteur de neige",
        "snowDifference": "Différence de hauteur de neige",
        "airTemperature": "Température de l'air",
        "airTemperatureMax": "Température maximale de l'air",
        "airTemperatureMin": "Température minimale de l'air",
        "surfaceTemperature": "Température à la surface",
        "surfaceHoar": "Formation potentielle de givre de surface",
        "surfaceHoarCalc": "Potential surface hoar formation (Lehning et. al.)",
        "dewPoint": "Température de rosée",
        "relativeHumidity": "Humidité relative",
        "windDirection": "Direction du vent",
        "windSpeed": "Vitesse du vent",
        "windGust": "Rafale de vent"
      }
    },
    "webcams": {
      "tooltips": {
        "minusTenMinutes": "Il y a 10 minutes",
        "minusOneHour": "Il y a 1 heure",
        "plusTenMinutes": "10 minutes plus tard",
        "plusOneHour": "1 heure plus tard"
      }
    },
    "button": {
      "add": "Ajouter une observation",
      "save": "Enregistrer l'observation",
      "delete": "Supprimer l'observation",
      "deleteConfirm": "Supprimer l'observation ?",
      "discard": "Abandonner",
      "copyDate": "Copier date de l'événement"
    },
    "comment": "Commentaire",
    "content": "Contenu",
    "dangerPatterns": "Modèle de risques",
    "dangerRating": "Indice de risques",
    "dangerSource": "Source de danger",
    "elevation": "Altitude",
    "elevationRange": "Plage d'altitude",
    "elevationLowerBound": "Limite inférieure",
    "elevationUpperBound": "Limite supérieure",
    "eventDate": "Date de l'événement",
    "eventType": "Type d'événement",
    "eventTypes": {
      "IMPORTANT": "Événement important",
      "NEIGHBOR_REGION": "Région voisine",
      "NORMAL": "Événement normal",
      "PERSON_DEAD": "Personnes emportées (décès)",
      "PERSON_INJURED": "Personnes emportées (blessures)",
      "PERSON_NO": "Pas de personnes emportées",
      "PERSON_UNINJURED": "Personnes emportées (aucun blessé)",
      "PERSON_UNKNOWN": "Événement (inconnu)",
      "TRAFFIC": "Trafic"
    },
    "externalURL": "URL externe (p. ex. banque d'images)",
    "fractureDepth": "Épaisseur de la cassure",
    "hasCoordinates": "Coordonnées disponibles",
    "incline": "Inclinaison de pente",
    "importantObservations": "Observations importantes",
    "latitude": "Latitude",
    "locationName": "Localisation",
    "longitude": "Longitude",
    "observationType": "Type d'observation",
    "personInvolvement": "Implication de personnes",
    "reportDate": "Date du rapport",
    "showTable": "Tableau",
    "stability": "Stabilité du manteau neigeux",
    "withoutCoordinates": "Observations sans coordonnées :",
    "sidebar": {
      "filter": {
        "title": "Filtre"
      },
      "legend": {
        "title": "Légende"
      },
      "sources": {
        "title": "Sources des données"
      },
      "views": {
        "title": "Vues"
      }
    }
  },
  "personInvolvement": {
    "Dead": "Personnes emportées (décès)",
    "Injured": "Personnes emportées (blessures)",
    "Yes": "Personnes emportées",
    "No": "Pas de personnes emportées",
    "Uninjured": "Personnes emportées (aucun blessé)",
    "Unknown": "Événement (inconnu)"
  },
  "units": {
    "cm": "cm",
    "mm": "mm",
    "m": "m"
  },
  "qfa": {
    "day": "Jour",
    "time": "Heure",
    "back": "Retour",
    "parameters": {
      "DUST": "poussière du Sahara",
      "N": "couverture nuageuse en /8",
      "Nh": "couverture nuageuse élevée en /8",
      "Nm": "couverture nuageuse moyenne en /8",
      "Nl": "faible couverture nuageuse en /8",
      "N-CU": "couverture de cumulus en /8",
      "AUSL.T": "Température de déclenchement",
      "SHW-IX": "Index Showalter",
      "WX -CUF": "temps significatif : NIL (rien), RASH (pluie), TS (orage)",
      "RR": "pluviométrie totale [mm]",
      "RR-str": "précipitations stratiformes",
      "CONV": "précipitations convectives [mm]",
      "SN": "précipitations sous forme de neige [mm]",
      "SN--RA": "limite de l'enneigement [m]",
      "QAO ": "{{value}} hPa eq. vent moyen, direction et force, [°] et [m/s]",
      "QAN": "vent moyen au sol, direction et force, [°] et [m/s]",
      "QANmax": "vent maximal (rafales) au sol, [m/s]",
      "T ": "{{value}} hPa eq. température [°C]",
      "T m": "température à {{value}}m [°C]",
      "T 2m": "température à 2m [°C]",
      "Tk 2m": "température à 2m [°K]",
      "T GND": "température au sol",
      "Max-ADI": "température maximale de mélange [°C]",
      "Min Max": "température min./max. ces dernières 24h",
      "FROST": "ligne de zéro degré [m]",
      "W cm": "500 hPa eq. vent vertical [cm/s]",
      "W --": "700 hPa eq. vent vertical [cm/s]",
      "W s": "{{value}} hPa eq. vent vertical [cm/s]",
      "H ": "{{value}} hPa hauteur géopotentielle [m]",
      "RF ": "{{value}} hPa eq. humidité relative [%]"
    }
  },
  "awsome": {
    "Aggregation band": "Bande d'agrégation",
    "Date": "Date",
    "Datetag": "Datetag",
    "Depth": "Profondeur",
    "Dry instability": "Instabilité du manteau neigeux sec",
    "fair (<0.77)": "moyen (<0,77)",
    "fair (<1.05)": "moyen (<1,05)",
    "Grain type": "Type de grain",
    "LWC index": "Indice LWC",
    "New snow": "Neige fraîche",
    "poor (<=3)": "mauvaise (<=3)",
    "poor (<0.95)": "mauvaise (<0,95)",
    "poor (>=0.77)": "mauvaise (>=0,77)",
    "Punstable": "Punstable",
    "rather stable (<0.7)": "plutôt stable (<0,7)",
    "rather stable (<1)": "plutôt stable (<1)",
    "rather stable (>1.05)": "plutôt stable (>1,05)",
    "Size estimate": "Estimation de la taille de l'avalanche",
    "SK38 (RTA > 0.8)": "SK38 (RTA > 0,8)",
    "very poor (<=0.5)": "très mauvaise (<=0,5)",
    "very poor (>3)": "très mauvaise (>3)",
    "Wet instability": "Instabilité humide"
  },
  "channelStatus": {
    "loading": "Chargement d'informations sur l'état du canal...",
    "triggerStatusChecks": "Vérifier statuts"
  },
  "lineaexport": {
    "searchfieldplaceholder": "Recherche de stations...",
    "hint": "Appuyez sur la touche Entrée pour ajouter"
  },
  "awsstats": {
    "title": "Statistiques SPA",
    "label": {
      "loading": "Chargement des données...",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "selectWeatherStation": "Sélectionner la station météo ",
      "selectMicroRegions": "Sélectionner les microrégions",
      "clearselection": "Effacer la sélection",
      "noMicroRegionsSelected": "aucune",
      "last7days": "7 derniers jours",
      "last30days": "30 derniers jours",
      "last90days": "90 derniers jours",
      "loadData": "Chargement des données",
      "charttypes": "types de diagrammes"
    },
    "charts": {
      "aws-observations": "Observations SPA",
      "aws-danger-rating": "Indice de risques",
      "aws-danger-rating-altitude": "Indice de risque en fonction de l'altitude",
      "aws-avalanche-activity-index": "Indice d'activité avalancheuse",
      "aws-danger-rating-danger-source-variants": "Types de sources de danger",
      "aws-danger-source-variants-matrix-parameter-stability": "Stabilité des types de sources de danger",
      "aws-danger-source-variants-matrix-parameter-frequency": "Fréquence des différents types de sources de danger",
      "aws-danger-source-variants-matrix-parameter-avalanche-size": "Taille des avalanches selon les différentes sources de danger"
    },
    "error": {
      "startDateBeforeEndDate": "La date de début doit être antérieure ou égale à la date de fin.",
      "failedLoadData": "Impossible de charger les données pour la période sélectionnée.",
      "startDateEndDateRequired": "Les dates de début et de fin sont obligatoires."
    }
  },
  "yearlystats": {
    "title": "Statistiques annuelles",
    "label": {
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "loaddata": "Chargement des données",
      "last90Days": "90 derniers jours",
      "last180Days": "180 derniers jours",
      "currentSeason": "Saison en cours",
      "regionCode": "Code région",
      "allRegions": "TOUT",
      "virtualTrainings": "Formations en ligne (dates)",
      "fieldTrainings": "Formations sur le terrain (dates)",
      "dangerRatingReference": "Référence indice de risque"
    },
    "charts": {
      "aws-danger-rating-micro-regions-bars": "Indice de risques SPA  par microrégions, en barres",
      "aws-danger-rating-micro-regions": "Indice de risques SPA  par microrégions",
      "aws-danger-rating-distribution": "Répartition de l'indice de risques SPA",
      "aws-danger-pattern-micro-regions": "Modèle de risques SPA par microrégions",
      "aws-avalanche-problem-micro-regions": "Situations avalancheuses SPA par microrégions",
      "aws-products": "Produits SPA",
      "aws-stress-level": "Niveau de stress de l'équipe"
    },
    "hint": {
      "dangerRatingReference": "Valeurs de référence pour la répartition des indices de danger selon les saisons, en gris",
      "dateChange": "Une fois la date modifiée, cliquer sur le bouton « Chargement des données »."
    }
  },
  "zodForm": {
    "valid": "Valide",
    "required": "Champ obligatoire",
    "invalidNumber": "Veuillez saisir un numéro valide."
  }
}
